import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { finalize, Observable, shareReplay } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { TokenService } from '../../state-management/token.service/token.service';
import { RefreshTokenResponse } from '../../../models/interfaces/auth-service.interface';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private baseUrl = environment.apiUrl;
  private refreshTokenRequest$: Observable<RefreshTokenResponse> | null = null;

  constructor(
    private http: HttpClient,
    private tokenService: TokenService) 
    {}

  signIn(loginFilter: 'EMAIL' | 'MOBILE', mobileNumberEmail: string): Observable<any> {
    const url = `${this.baseUrl}/signIn`;
    
    const params = new HttpParams()
      .set('loginFilter', loginFilter)
      .set('mobileNumberEmail', mobileNumberEmail);

    return this.http.post(url, null, { params });
  }

  signUp(data: {
    audience: boolean;
    dateOfBirth: string;
    email: string;
    fullName: string;
    mobileNumber?: string;
  }): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', // Set Content-Type header
    });

    return this.http.post(`${this.baseUrl}/signUp`, data, { headers });
  }



  getAccessTokenFromRefreshToken(): Observable<RefreshTokenResponse> {
    if (!this.refreshTokenRequest$) {
      const refreshToken = this.tokenService.getRefreshToken();
      this.refreshTokenRequest$ = this.http.post<RefreshTokenResponse>(`${this.baseUrl}/getAccessTokenFromRefreshToken`, refreshToken)
        .pipe(
          shareReplay(1), // Share result among multiple subscribers
          finalize(() => this.refreshTokenRequest$ = null) // Reset when complete
        );
    }
    return this.refreshTokenRequest$;
  }

  setLocalValue(key:string,value:string): void {
    localStorage.setItem(key, value);
  }

  logout(): void {
    localStorage.removeItem('token');
  }

  sendOtp(email: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/auth/send-otp`, { email });
  }

  verifySignUpOtp(loginFilter: string, mobileNumberEmail: string | number, otp: string,staySignIn:boolean): Observable<any> {
    const body = {
      "emailMobile": mobileNumberEmail,
      "otp": otp,
    }

    const params = new HttpParams()
      .set('loginFilter', loginFilter)
      .set('otp', otp).set('staySignIn', staySignIn);

    return this.http.post(`${this.baseUrl}/verifyOtp`,body, { params });
  }

  verifySignInOtp(loginFilter: string, mobileNumberEmail: string | number, otp: string): Observable<any> {
    const body ={
      "emailMobile":mobileNumberEmail,
      "otp": otp,
    }

    const params = new HttpParams().set('loginFilter', loginFilter)

    return this.http.post(`${this.baseUrl}/verifySignInOtp` ,body, { params });
  }
  
  resendOtp(email:string,loginFilter: string,): Observable<any> {
    const params = new HttpParams()
    .set('email', email).set('loginFilter',loginFilter)
    return this.http.post(`${this.baseUrl}/resendOTP`,null, {params});
  }


  logOut(mobileNumberEmail:string,token:string):Observable<any> {
    const params = new HttpParams()
      .set('email', mobileNumberEmail)
      .set('token', token)

    return this.http.post(`${this.baseUrl}/logoutUser`,null,{params});
  }
}
